// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"a37957ada17ddfd46b11","293":"518e656cf6d01c50683a"}[chunkId] + ".js";
};